<div class="grid">
	<div class="col-12 lg:col-6">
		<div class="card">
			<h5>Toast</h5>
			<p-toast key="tst"></p-toast>

			<button
				type="button"
				pButton
				(click)="showSuccessViaToast()"
				label="Success"
				class="p-button-success mr-2 mb-2"></button>
			<button
				type="button"
				pButton
				(click)="showInfoViaToast()"
				label="Info"
				class="p-button-info mr-2 mb-2"></button>
			<button
				type="button"
				pButton
				(click)="showWarnViaToast()"
				label="Warn"
				class="p-button-warning mr-2 mb-2"></button>
			<button
				type="button"
				pButton
				(click)="showErrorViaToast()"
				label="Error"
				class="p-button-danger mb-2"></button>
		</div>
	</div>

	<div class="col-12 lg:col-6">
		<div class="card">
			<h5>Messages</h5>
			<button
				type="button"
				pButton
				(click)="showSuccessViaMessages()"
				label="Success"
				class="p-button-success mr-2 mb-2"></button>
			<button
				type="button"
				pButton
				(click)="showInfoViaMessages()"
				label="Info"
				class="p-button-info mr-2 mb-2"></button>
			<button
				type="button"
				pButton
				(click)="showWarnViaMessages()"
				label="Warn"
				class="p-button-warning mr-2 mb-2"></button>
			<button
				type="button"
				pButton
				(click)="showErrorViaMessages()"
				label="Error"
				class="p-button-danger mb-2"></button>

			<p-messages [value]="msgs"></p-messages>
		</div>
	</div>

	<div class="col-12 lg:col-8">
		<div class="card">
			<h5>Inline Message</h5>
			<div class="mt-4">
				<input type="text" pInputText placeholder="Username" class="ng-dirty ng-invalid p-invalid mr-2" />
				<p-message severity="error" text="Field is required"></p-message>
			</div>

			<div class="mt-4">
				<input type="text" pInputText placeholder="Email" class="ng-dirty ng-invalid p-invalid mr-2" />
				<p-message severity="error"></p-message>
			</div>
		</div>
	</div>

	<div class="col-12 lg:col-4">
		<div class="card">
			<h5>Help Text</h5>
			<div class="field p-fluid">
				<label for="username">Username</label>
				<input
					id="username"
					type="username"
					aria-describedby="username-help"
					class="ng-dirty ng-invalid"
					pInputText />
				<small id="username-help" class="p-error">Username is not available.</small>
			</div>
		</div>
	</div>
</div>
